import React from 'react';

import Expander from '../Expander/Expander';

import { ContainerPropTypes } from './Container.types';
import isEmpty from '@src/utils/isEmpty';

const Container: React.FC<ContainerPropTypes> = ({
  style = {},
  bgStyle = {},
  containerRef,
  attr,
  className = '',
  children,
  background,
  id,
  elementId,
  HtmlTag = 'section',
}) => {
  return (
    <HtmlTag
      ref={containerRef}
      id={elementId}
      data-type={attr}
      data-id={id}
      style={style}
      className={`relative z-1 mx-auto mb-[8rem] max-w-[160rem] px-[2.4rem] md:px-[6.3rem] lg:px-[6.4rem] xl:px-[12.8rem] 3xl:px-[4rem] 4xl:px-[0] ${className}`}
    >
      {children}
      {background && (
        <Expander className={`absolute right-[0] top-[0] -z-10 ${background}`}></Expander>
      )}
      {!isEmpty({ value: bgStyle }) && (
        <Expander style={bgStyle} className={`absolute right-[0] top-[0] -z-10`}></Expander>
      )}
    </HtmlTag>
  );
};

export default Container;
